import { useTokenValidation } from "../hooks";

export const TokenManager = () => {
  useTokenValidation();

  return null;
};
